import { Suspense, useMemo, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { auth } from "./firebase";
import "./pages/client.scss";
import { Login } from "./pages/Login";
import { StoryBook } from "./pages/StoryBook";
import { TestCoverage } from "./pages/TestCoverage";

const App = () => {
  const [user, loading] = useAuthState(auth);
  const [key, setKey] = useState<number>(0);

  /**
   * Holds the active router depending on the login state
   * @value key is used to trigger an rerender on router change
   */
  const router = useMemo(() => {
    let activeRouter = createBrowserRouter([
      { path: "*", element: <p>loading</p> },
    ]);
    switch (true) {
      case !!loading:
        activeRouter = createBrowserRouter([
          { path: "*", element: <p>loading</p> },
        ]);
        break;
      case !!user:
        activeRouter = createBrowserRouter([
          {
            index: true,
            element: <StoryBook />,
          },
          { path: "test", element: <TestCoverage /> },
        ]);
        break;
      default:
        activeRouter = createBrowserRouter([{ path: "*", element: <Login /> }]);
        break;
    }
    setKey(key + 1);
    return activeRouter;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, user]);

  return (
    <Suspense fallback={<p>loading</p>}>
      <RouterProvider router={router} key={key} />
    </Suspense>
  );
};

export default App;
